import Tutorial from './Tutorial';

export default Tutorial;
